import { render, staticRenderFns } from "./BaseStepRow.vue?vue&type=template&id=54912f38&scoped=true"
import script from "./BaseStepRow.vue?vue&type=script&lang=js"
export * from "./BaseStepRow.vue?vue&type=script&lang=js"
import style0 from "./BaseStepRow.vue?vue&type=style&index=0&id=54912f38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54912f38",
  null
  
)

export default component.exports